const commonCSVColumns = [
    {
        label: "load_id",
        key: "loadId"
    },
    {
        label: "carrier_id",
        key: "carrierId"
    },
    {
        label: "service",
        key: "serviceId"
    },
    {
        label: "origin_city",
        key: "originCity"
    },
    {
        label: "origin_state",
        key: "originState"
    }
];

export const CSVLABEL_ARRIVAL_AT_PICK_STOP_CER = [
    ...commonCSVColumns,
    {
        label: "carrier_actual_pickup_data_time",
        key: "actualArrivalTimestampCarrier"
    },
    {
        label: "event_reporting_date_time",
        key: "tmsActualArrivalTimestampReportedAt"
    }
];

export const CSVLABEL_DEPARTURE_FROM_PICK_STOP_CER = [
    ...commonCSVColumns,
    {
        label: "carrier_actual_depart_data_time",
        key: "actualDepartureTimestampCarrier"
    },
    {
        label: "event_reporting_date_time",
        key: "tmsActualDepartureTimestampReportedAt"
    }
];

export const CSVLABEL_ARRIVAL_AT_DROP_STOP_CER = [
    ...commonCSVColumns,
    {
        label: "carrier_actual_delivery_data_time",
        key: "actualArrivalTimestampCarrier"
    },
    {
        label: "event_reporting_date_time",
        key: "tmsActualArrivalTimestampReportedAt"
    },
    {
        label: "drop_location",
        key: "destinationLocation"
    }
];

export const CSVLABEL_DEPARTURE_FROM_DROP_STOP_CER = [
    ...commonCSVColumns,
    {
        label: "carrier_actual_depart_data_time",
        key: "actualDepartureTimestampCarrier"
    },
    {
        label: "event_reporting_date_time",
        key: "tmsActualDepartureTimestampReportedAt"
    },
    {
        label: "drop_location",
        key: "destinationLocation"
    }
];
